<template>
  <div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-modal="true"
      :class="{ show: showModal }"
    >
      <div class="modal-dialog delete-modal-dialog">
        <div class="modal-content delete-modal-content">
          <div class="delete-modal-header">
            <div class="delete-modal-heading">
              <span class="delete-modal-glyph">
                <i class="pi pi-exclamation-triangle"></i>
              </span>
              <div class="delete-modal-heading-text">
                <h5 class="delete-modal-title">{{ modalTitle }}</h5>
                <p class="delete-modal-subtitle">This action cannot be undone.</p>
              </div>
            </div>
            <button
              type="button"
              class="delete-modal-close"
              @click="closeModal()"
              aria-label="Close"
            >
              <i class="pi pi-times"></i>
            </button>
          </div>

          <div class="delete-modal-body">
            <p v-if="additionalMessage" class="delete-modal-message">
              {{ additionalMessage }}
            </p>
            <p class="delete-modal-message">{{ confirmationMessage }}</p>
          </div>

          <div class="delete-modal-footer">
            <button
              type="button"
              class="btn btn-custom-secondary"
              @click="closeModal()"
            >
              Cancel
            </button>
            <button
              @click="deleteRecord()"
              type="submit"
              class="btn btn-custom-primary"
              :disabled="isLoading"
            >
              <span
                v-if="isLoading"
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
              <span v-else>{{ confirmLabel }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    deleteFunction: {
      type: Function,
      required: true,
    },
    isVoidInvoice: {
      type: Function,
      required: false,
      default: false,
    },
    additionalMessage: String,
    title: {
      type: String,
      default: '',
    },
    confirmationMessage: {
      type: String,
      default: 'Are you sure you want to delete this record?',
    },
    confirmLabel: {
      type: String,
      default: 'Delete',
    },
    isLoadingOverride: {
      type: Boolean,
      default: false,
    },
    loadingManagedExternally: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showModal: true,
    };
  },
  computed: {
    modalTitle() {
      return this.title || `Confirm ${this.isVoidInvoice ? '' : 'Delete'}`.trim();
    },
    isLoading() {
      if (this.loadingManagedExternally) return this.isLoadingOverride;
      return [
        this.templateIsLoading,
        this.announcementIsLoading,
        this.shiureiTorahIsLoading,
        this.donationIsLoading,
        this.zmanimIsLoading,
        this.zmanim_NIsLoading,
        this.minyanimIsLoading,
        this.minyan_NIsLoading,
        this.minyanRoll_NIsLoading,
        this.dateTimeBannerIsLoading,
        this.posterIsLoading,
        this.apiKeyIsLoading,
        this.minyanimCountdownIsLoading,
        this.ticketIsLoading,
        this.eventIsLoading,
        this.memberIsLoading,
        this.roomIsLoading,
        this.minyanimTypeIsLoading,
        this.folderIsLoading,
        this.screenIsLoading,
        this.screenArtboardIsLoading,
        this.organizationIsLoading,
      ].some(Boolean);
    },
    templateIsLoading() {
      return this.$store.getters.template?.isLoading ?? false;
    },
    templatesIsLoading() {
      return this.$store.getters.templates?.isLoading ?? false;
    },
    announcementIsLoading() {
      return this.$store.getters.announcement?.isLoading ?? false;
    },
    announcementsIsLoading() {
      return this.$store.getters.announcements?.isLoading ?? false;
    },
    shiureiTorahIsLoading() {
      return this.$store.getters.shiureiTorah?.isLoading ?? false;
    },
    shiureiTorahsIsLoading() {
      return this.$store.getters.shiureiTorahs?.isLoading ?? false;
    },
    donationIsLoading() {
      return this.$store.getters.donation?.isLoading ?? false;
    },
    donationsIsLoading() {
      return this.$store.getters.donations?.isLoading ?? false;
    },
    zmanimIsLoading() {
      return this.$store.getters.zmanim?.isLoading ?? false;
    },
    zmanimsIsLoading() {
      return this.$store.getters.zmanims?.isLoading ?? false;
    },
    zmanim_NIsLoading() {
      return this.$store.getters.zmanim_N?.isLoading ?? false;
    },
    zmanims_NIsLoading() {
      return this.$store.getters.zmanims_N?.isLoading ?? false;
    },
    minyanimIsLoading() {
      return this.$store.getters.minyanim?.isLoading ?? false;
    },
    minyanimsIsLoading() {
      return this.$store.getters.minyanims?.isLoading ?? false;
    },
    minyan_NIsLoading() {
      return this.$store.getters.minyan_N?.isLoading ?? false;
    },
    minyans_NIsLoading() {
      return this.$store.getters.minyans_N?.isLoading ?? false;
    },
    minyanRoll_NIsLoading() {
      return this.$store.getters.minyanRoll_N?.isLoading ?? false;
    },
    minyanRolls_NIsLoading() {
      return this.$store.getters.minyanRolls_N?.isLoading ?? false;
    },
    minyanimCountdownIsLoading() {
      return this.$store.getters.minyanimCountdown?.isLoading ?? false;
    },
    minyanimCountdownsIsLoading() {
      return this.$store.getters.minyanimCountdowns?.isLoading ?? false;
    },
    dateTimeBannerIsLoading() {
      return this.$store.getters.dateTimeBanner?.isLoading ?? false;
    },
    dateTimeBannersIsLoading() {
      return this.$store.getters.dateTimeBanners?.isLoading ?? false;
    },
    posterIsLoading() {
      return this.$store.getters.poster?.isLoading ?? false;
    },
    postersIsLoading() {
      return this.$store.getters.posters?.isLoading ?? false;
    },
    apiKeyIsLoading() {
      return this.$store.getters.apiKey?.isLoading ?? false;
    },
    apiKeysIsLoading() {
      return this.$store.getters.apiKeys?.isLoading ?? false;
    },
    ticketIsLoading() {
      return this.$store.getters.ticket?.isLoading ?? false;
    },
    ticketsIsLoading() {
      return this.$store.getters.tickets?.isLoading ?? false;
    },
    eventIsLoading() {
      return this.$store.getters.event?.isLoading ?? false;
    },
    eventsIsLoading() {
      return this.$store.getters.events?.isLoading ?? false;
    },
    memberIsLoading() {
      return this.$store.getters.member?.isLoading ?? false;
    },
    membersIsLoading() {
      return this.$store.getters.members?.isLoading ?? false;
    },
    roomIsLoading() {
      return this.$store.getters.room?.isLoading ?? false;
    },
    roomsIsLoading() {
      return this.$store.getters.rooms?.isLoading ?? false;
    },
    minyanimTypeIsLoading() {
      return this.$store.getters.minyanimType?.isLoading ?? false;
    },
    minyanimTypesIsLoading() {
      return this.$store.getters.minyanimTypes?.isLoading ?? false;
    },
    folderIsLoading() {
      return this.$store.getters.folder?.isLoading ?? false;
    },
    foldersIsLoading() {
      return this.$store.getters.folders?.isLoading ?? false;
    },
    screenIsLoading() {
      return this.$store.getters.screen?.isLoading ?? false;
    },
    screensIsLoading() {
      return this.$store.getters.screens?.isLoading ?? false;
    },
    screenArtboardIsLoading() {
      return this.$store.getters.screenArtboard?.isLoading ?? false;
    },
    screenArtboardsIsLoading() {
      return this.$store.getters.screenArtboards?.isLoading ?? false;
    },
    screenArtboardContentIsLoading() {
      return this.$store.getters.screenArtboardContent?.isLoading ?? false;
    },
    organizationIsLoading() {
      return this.$store.getters.organization?.isLoading ?? false;
    },
    account() {
      return this.$store.getters.account.data;
    },
  },
  methods: {
    closeModal() {
      this.$emit('closeDeleteConfirmationModal');
    },
    async deleteRecord() {
      if (this.deleteFunction) {
        try {
          const res = await this.deleteFunction();
          if (res != null) {
            this.closeModal();
            this.$emit('refreshRecords');
          }
        } catch (error) {
          console.error('Error during deletion:', error);
        }
      }
    },
  },
};
</script>
<style scoped>
.modal {
  display: none;
  background-color: rgba(17, 24, 39, 0.45);
  backdrop-filter: blur(2px);
  z-index: 1000;
}

.modal.show {
  display: block;
}

.delete-modal-dialog {
  max-width: min(440px, 92%);
  margin: 8vh auto;
}

.delete-modal-content {
  display: flex;
  flex-direction: column;
  max-height: min(88vh, calc(100dvh - 32px));
  border: 1px solid var(--color-border);
  border-radius: var(--radius-xl);
  background: var(--color-bg-canvas);
  box-shadow: var(--shadow-lg);
  overflow: hidden;
}

.delete-modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  padding: 1.3rem 1.5rem 0;
}

.delete-modal-heading {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  min-width: 0;
}

.delete-modal-glyph {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  margin-top: 2px;
  border-radius: var(--radius-md);
  background: rgba(255, 56, 60, 0.09);
  color: #ff383c;
  font-size: 1.1rem;
}

.delete-modal-title {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 600;
  color: var(--color-text-primary);
}

.delete-modal-subtitle {
  margin: 3px 0 0;
  font-size: 0.82rem;
  color: var(--color-text-muted);
}

.delete-modal-close {
  width: 30px;
  height: 30px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: var(--radius-sm);
  background: transparent;
  color: var(--color-text-muted);
  cursor: pointer;
  transition: background-color .15s ease, color .15s ease;
}

.delete-modal-close:hover {
  background: var(--color-bg-muted);
  color: var(--color-text-primary);
}

.delete-modal-close .pi {
  font-size: 0.85rem;
}

.delete-modal-body {
  overflow-y: auto;
  overflow-x: hidden;
  padding: 1.3rem 1.5rem 0.5rem;
}

.delete-modal-message {
  margin: 0 0 10px;
  font-size: 0.9rem;
  font-weight: 400;
  line-height: 1.45;
  color: var(--color-text-secondary);
}

.delete-modal-message:last-child {
  margin-bottom: 0;
}

.delete-modal-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 8px;
  padding: 1rem 1.5rem 1.4rem;
  border-top: 1px solid var(--color-divider);
}

.delete-modal-footer .btn {
  min-width: 110px;
  padding: 0.55rem 1.1rem;
  font-size: 0.875rem;
}

.btn-custom-primary {
  background-color: #ff383c !important;
  border-color: #ff383c !important;
}

@media (max-width: 991.98px) {
  .delete-modal-dialog {
    max-width: 92%;
    margin: 20px auto;
  }

  .delete-modal-content {
    max-height: calc(100dvh - 40px);
  }
}

@media (max-width: 575.98px) {
  .delete-modal-dialog {
    max-width: 92%;
    margin: 16px auto;
  }

  .delete-modal-content {
    max-height: calc(100dvh - 32px);
  }

  .delete-modal-header {
    padding: 1.1rem 1.1rem 0;
  }

  .delete-modal-body {
    padding: 1.1rem 1.1rem 0.4rem;
  }

  .delete-modal-footer {
    padding: 0.85rem 1.1rem 1.1rem;
  }

  .delete-modal-footer .btn {
    flex: 1 1 0;
    min-width: 0;
  }
}
</style>
